import * as q from '@Alternatives/Notifications/Domain/queries';
import VueCqrs from '@cqrs/vue-component-cqrs';
import Component from 'vue-class-component';

@Component
export default class NotificationsQueries extends VueCqrs
{
	runNotificationByIdQueryV1(workspaceId: number, projectId: number, alternativesListId: number, notificationId: number)
	{
		const query = q.buildNotificationByIdQueryV1(workspaceId, projectId, alternativesListId, notificationId);
		this.$query(query);
	}

	runNotificationsPageQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildNotificationsPageQueryV1(workspaceId, projectId);
		this.$query(query);
	}
}